import { apiClient } from '@/api/client'
import type { MaintenanceNote } from './types'

const BASE = '/portal/controllers/api/v2/maintenance-notes'

export async function fetchMaintenanceNotes(
  controllerId: string,
  year?: number,
  month?: number,
): Promise<MaintenanceNote[]> {
  const params: Record<string, number> = {}
  if (year) params.year = year
  if (month) params.month = month
  const { data } = await apiClient.get<{ notes: MaintenanceNote[] }>(`${BASE}/controller/${controllerId}`, {
    params,
  })
  return data.notes
}

export async function createMaintenanceNote(params: {
  controller_id: string
  note: string
  year: number
  month: number
}): Promise<MaintenanceNote> {
  const { data } = await apiClient.post<{ note: MaintenanceNote }>(BASE, params)
  return data.note
}

export async function updateMaintenanceNote(
  noteId: number,
  params: { note: string; year: number; month: number },
): Promise<MaintenanceNote> {
  const { data } = await apiClient.put<{ note: MaintenanceNote }>(`${BASE}/${noteId}`, params)
  return data.note
}

export async function deleteMaintenanceNote(noteId: number): Promise<void> {
  await apiClient.delete(`${BASE}/${noteId}`)
}
